import { render, staticRenderFns } from "./InformerCard.htm?vue&type=template&id=712992da&scoped=true&"
import script from "./InformerCard.ts?vue&type=script&lang=js&"
export * from "./InformerCard.ts?vue&type=script&lang=js&"
import style0 from "./InformerCard.scss?vue&type=style&index=0&id=712992da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712992da",
  null
  
)

export default component.exports